import { Component, OnDestroy, OnInit } from "@angular/core";
import { EntityService } from "@app/entity/services/entity.service";
import { LoadingState } from "@app/root-store/api-result.state";
import { IClareTableComponent, TableFilterProperties } from "@app/shared/model/action.model";
import { TablePropertiesService } from "@app/shared/services/table-properties.service";
import { User } from "@app/user/model/user";
import { UserManagementService } from "@app/user/service/user-management.service";
import { Observable, Subject } from "rxjs";
import { map, switchMap, take, takeUntil, tap } from "rxjs/operators";

@Component({
    selector: "app-staff-list",
    templateUrl: "./staff-list.component.html",
})
export class StaffListComponent implements OnInit, OnDestroy, IClareTableComponent<User> {
    private unsubscribe$ = new Subject<void>();

    public dataSource$: Observable<any>;
    public callState: LoadingState;

    public columns = {
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        companyName: "Company Name",
        roleName: "Role",
        createdSignin: "Created Login",
    };

    public tableActionOptions = TablePropertiesService.getActionOptions(this.getTableActions());
    public tableProperties$ = TablePropertiesService.getTableFilterProperties$({
        columnsToSearch: ["firstName", "lastName", "email", "companyName", "roleName"],
    });

    getTableActions() {
        return (selectedRow: User) => [TablePropertiesService.implementDelete(() => this.deleteUser(selectedRow))];
    }

    updateTableProperties(updatedProperties: Partial<TableFilterProperties>) {
        return TablePropertiesService.updateTableProperties(this.tableProperties$, updatedProperties);
    }

    constructor(private readonly userService: UserManagementService, private readonly entityService: EntityService) {}

    ngOnInit() {
        this.userService.dispatchAndSelectAllUserRoles();
        this.entityService.loadAuthUserEntities$().pipe(takeUntil(this.unsubscribe$)).subscribe();
        this.dataSource$ = this.userService.getAllUserList().pipe(
            tap(_ => (this.callState = LoadingState.loaded)),
            switchMap(data => this.tableProperties$.pipe(map(props => TablePropertiesService.searchData(data, props))))
        );
    }

    editUser(id: number) {
        this.userService
            .getUser(id)
            .pipe(
                tap(user => this.userService.goToEditPage(user.entityId, id)),
                take(1)
            )
            .subscribe();
    }

    deleteUser(user: User) {
        this.userService.deleteUser(user, "staff-list");
    }

    ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    }
}
